import { Input } from 'antd';
import get from 'lodash/get';
import React from 'react';

import I18n from '../../i18n';
import AppContext from '../../services/Context';
import styled from '../../styled-components';
import Icon from '../Icon';

type PropType = {
  name: string;
  className?: string;
  label?: string;
  placeholder?: string;
  value?: any;
  withError?: boolean;
  disabled?: boolean;
  setFieldValue: Function;
  setTouched: Function;
  onFocus: Function;
  onBlur: Function;
};

type StateType = {
  hidden: boolean;
};

class PasswordField extends React.Component<PropType, StateType> {
  state = { hidden: true };

  toggleVisible = () => this.setState({ hidden: !this.state.hidden });

  render() {
    const { name, className, value, placeholder, disabled, setFieldValue, setTouched } = this.props;
    const type = !!this.state.hidden ? 'password' : 'text';
    const iconName = !!this.state.hidden ? 'eye-slash' : 'eye';

    return (
      <AppContext.Consumer>
        {({ theme, locale }) => (
          <InputWrapper theme={theme} className={`form-input-wrapper_${name} ${className}`}>
            <Input
              // theme={theme}
              className={`form-input_${name} ${className}`}
              type={type}
              name={name}
              placeholder={I18n.l(placeholder || '')}
              value={value}
              disabled={disabled}
              autoComplete="new-password"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFieldValue(name, e.target.value);
                setTouched({ [name]: true });
              }}
              suffix={
                <div className="icon-wrapper" onClick={this.toggleVisible}>
                  <Icon name={iconName} />
                </div>
              }
            />
          </InputWrapper>
        )}
      </AppContext.Consumer>
    );
  }
}

const InputWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  ${({ theme }) => get(theme, 'form.inputWrapper')};

  &.search {
    ${({ theme }) => get(theme, 'form.searchWrapper')};
  }
  &.auth-style {
    ${({ theme }) => get(theme, 'form.authWrapper')};
  }
`;

const IconWrapper = styled.div`
  cursor: pointer;
  margin-left: 10px;
`;

export default PasswordField;
